import { useIoContext, useStore } from '~/contexts';
import { useNetworkRetry } from '~/hooks/networkRetry/useNetworkRetry';
import { useSetAuthToken } from '~/hooks/useSetAuthToken';
import { selectors } from '~/store/state-selectors';
export function useBootNetworkRetry(schedule) {
    const bootFailedOnNetwork = useStore(selectors.isBootNetworkFailure);
    const setAuthToken = useSetAuthToken();
    const { cookies } = useIoContext();
    return useNetworkRetry({
        active: bootFailedOnNetwork,
        attempt: ()=>setAuthToken(cookies.getAuthToken()),
        schedule
    });
}
